import { Navigate, type RouteObject } from "react-router-dom";

import {
  CashFlowPage,
  FinanceIndexRedirect,
  FinanceLayout,
  FiscalDocuments,
  ProjectReceivables,
} from "@/router/lazyPages/finance";
import {
  AccountShell,
  ClientBudgets,
  FormFieldGallery,
  Home,
  CompanyTracking,
  SettingsProfile,
} from "@/router/lazyPages/home";
import { NotFound } from "@/router/lazyPages/shared";
import { skeletonRoute } from "@/router/skeletonRoute";
import { SkeletonVariant } from "@/types/routeSkeleton";
import {
  FinanceReceivablesCreateRedirect,
  FinanceReceivablesEditRedirect,
} from "./financeRedirects";

export const homeShellRoutes: RouteObject[] = [
  {
    path: "/home",
    element: <Home />,
  },
  ...(import.meta.env.DEV
    ? [
        {
          path: "/__forms",
          element: <FormFieldGallery />,
        },
      ]
    : []),
  {
    path: "/dashboard",
    handle: { permission: "nav.dashboard" },
    element: <Home />,
  },
  {
    path: "/acompanhamento",
    handle: { permission: "nav.dashboard" },
    element: <CompanyTracking />,
  },
  skeletonRoute({
    path: "/client-budgets",
    permission: "project.clientBudgets.view",
    skeleton: {
      skeletonVariant: SkeletonVariant.List,
      skeletonListShowPrimaryAction: true,
      skeletonListShowSearch: true,
    },
    element: <ClientBudgets />,
  }),
  {
    path: "/profile",
    handle: { sidebar: "account" },
    element: <AccountShell />,
    children: [
      { index: true, element: <SettingsProfile /> },
      { path: "*", element: <NotFound /> },
    ],
  },
  {
    path: "/budget",
    element: <Navigate to="/finance" replace />,
  },
  {
    path: "/finance",
    handle: { permission: "nav.finance" },
    element: <FinanceLayout />,
    children: [
      { index: true, element: <FinanceIndexRedirect /> },
      { path: "payables", element: <Navigate to="/dashboard" replace /> },
      { path: "payables/new", element: <Navigate to="/dashboard" replace /> },
      { path: "payables/:id/edit", element: <Navigate to="/dashboard" replace /> },
      skeletonRoute({
        path: "receivables",
        permission: "finance.receivables.view",
        skeleton: {
          skeletonVariant: SkeletonVariant.List,
          skeletonListShowPrimaryAction: true,
          skeletonListShowSearch: true,
        },
        element: <ProjectReceivables />,
      }),
      {
        path: "receivables/new",
        handle: { permission: "finance.receivables.write" },
        element: <FinanceReceivablesCreateRedirect />,
      },
      {
        path: "receivables/:id/edit",
        handle: { permission: "finance.receivables.write" },
        element: <FinanceReceivablesEditRedirect />,
      },
      skeletonRoute({
        path: "invoices",
        permission: "finance.fiscal.view",
        skeleton: {
          skeletonVariant: SkeletonVariant.List,
          skeletonListShowPrimaryAction: false,
          skeletonListShowSearch: true,
        },
        element: <FiscalDocuments />,
      }),
      skeletonRoute({
        path: "cash-flow",
        permission: "finance.cashFlow.view",
        skeleton: {
          skeletonVariant: SkeletonVariant.List,
          skeletonListShowPrimaryAction: false,
          skeletonListShowSearch: false,
        },
        element: <CashFlowPage />,
      }),
    ],
  },
];

export const homeFormRoutes: RouteObject[] = [
  { path: "/profile/edit", element: <Navigate to="/profile" replace /> },
  { path: "/settings/profile", element: <Navigate to="/profile" replace /> },
  {
    path: "/settings/profile/edit",
    element: <Navigate to="/profile" replace />,
  },
];
